import { render, staticRenderFns } from "./ProjectMembersOverview.vue?vue&type=template&id=4dbcb5da&scoped=true"
import script from "./ProjectMembersOverview.vue?vue&type=script&lang=ts"
export * from "./ProjectMembersOverview.vue?vue&type=script&lang=ts"
import style0 from "./ProjectMembersOverview.vue?vue&type=style&index=0&id=4dbcb5da&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dbcb5da",
  null
  
)

export default component.exports